import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import { __t, applyTranslations } from 'utils/language';
import useManagedInputValue from 'hooks/use-managed-input-value';

import type { MixedSelectDropdownItem } from 'types';

import './shared-access-product-filters.scss';

applyTranslations(require('./shared-access-product-filters.i18n.json'));

export const DEFAULT_VALUE = '_all';

type Props = {
  categories: Array<string>,
  brands: Array<string>,
  colors: Array<string>,
  currentCategory: string,
  currentBrand: string,
  currentColor: string,
  onCategoryChange: (a: string) => void,
  onBrandChange: (a: string) => void,
  onColorChange: (a: string) => void
};

function mapStringsToOptions(selectedValue: string, allLabel: string, data: Array<string> = []): Array<MixedSelectDropdownItem> {
  return [
    {
      identifier: DEFAULT_VALUE,
      isDisabled: false,
      isSelected: DEFAULT_VALUE === selectedValue,
      label: allLabel,
      value: DEFAULT_VALUE
    },
    ...data.map((entry) => ({
      identifier: entry,
      isDisabled: false,
      isSelected: entry === selectedValue,
      label: entry,
      value: entry
    }))
  ];
}

const SharedAccessProductFilters = (
  {
    categories,
    brands,
    colors,
    currentCategory = DEFAULT_VALUE,
    currentBrand = DEFAULT_VALUE,
    currentColor = DEFAULT_VALUE,
    onCategoryChange,
    onBrandChange,
    onColorChange
  }: Props
): JSX.Element => {
  const [category, setCategory] = useManagedInputValue(currentCategory);
  const [brand, setBrand] = useManagedInputValue(currentBrand);
  const [color, setColor] = useManagedInputValue(currentColor);

  return (
    <section className="shared-access-product-filters">
      <div className="shared-access-product-filters__label">
        {__t('shared_access_product_filters.filter_label')}
      </div>
      <div className="shared-access-product-filters__filters">
        <MixedSelectDropdown
          name="category-select"
          className="shared-access-product-filters__select"
          items={mapStringsToOptions(category, __t('shared_access_product_filters.all_categories_label'), categories)}
          onItemsToggle={(items) => {
            const newValue = items.find(item => item.isSelected)?.value ?? category;
            setCategory(newValue);
            onCategoryChange(newValue);
          }}
        />
        <MixedSelectDropdown
          name="brand-select"
          className="shared-access-product-filters__select"
          items={mapStringsToOptions(brand, __t('shared_access_product_filters.all_brands_label'), brands)}
          onItemsToggle={(items) => {
            const newValue = items.find(item => item.isSelected)?.value ?? brand;
            setBrand(newValue);
            onBrandChange(newValue);
          }}
        />
        <MixedSelectDropdown
          name="color-select"
          className="shared-access-product-filters__select"
          items={mapStringsToOptions(color, __t('shared_access_product_filters.all_colors_label'), colors)}
          onItemsToggle={(items) => {
            const newValue = items.find(item => item.isSelected)?.value ?? brand;
            setColor(newValue);
            onColorChange(newValue);
          }}
        />
      </div>
    </section>
  );
};

export default SharedAccessProductFilters;
